import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { AppDrawer } from '@/components/AppDrawer';
import { Pet } from '@/components/Pet';
import { confetti } from '@/lib/confetti';
import { m, msg } from '@/lib/i18n';
import type { AppState } from '@/lib/types';

const KEY = 'cr_pet_stage';

function seen(memberId: number): number | null {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '{}')[memberId];
    return typeof v === 'number' ? v : null;
  } catch {
    return null;
  }
}
function remember(memberId: number, stage: number) {
  try {
    const all = JSON.parse(localStorage.getItem(KEY) ?? '{}');
    all[memberId] = stage;
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* storage unavailable: at worst the celebration shows again */
  }
}

/** When your companion reaches a new stage, celebrate it once. */
export function GrowthWatcher({ state }: { state: AppState }) {
  const pet = state.pet;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const before = seen(state.me.id);
    if (before === null) remember(state.me.id, pet.stage); // first visit: nothing to celebrate yet
    else if (pet.stage > before) {
      remember(state.me.id, pet.stage);
      setOpen(true);
      confetti();
    }
  }, [pet.stage, state.me.id]);
  return (
    <AppDrawer
      open={open}
      onOpenChange={setOpen}
      title={m.pet_grew_title({ name: pet.name })}
      footer={
        <Button size="lg" onClick={() => setOpen(false)}>
          {m.yay()}
        </Button>
      }
    >
      <div className="grid justify-items-center gap-3 text-center">
        <Pet kind={pet.kind} mood="thriving" size={180} scale={pet.size} crown={pet.crown} outfit={pet.outfit} pettable label={pet.name} />
        <p className="text-muted-foreground">{m.pet_grew_body({ name: pet.name, stage: msg(`pet_${pet.kind}_stage_${pet.stage}`) })}</p>
      </div>
    </AppDrawer>
  );
}
